module.exports = __webpack_public_path__ + "static/media/ru-RU.a81ec8ba.md";